import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Pie } from "@ant-design/plots";
import { Spin, Empty } from "antd";
const PieChart = (props) => {
  const { loading } = props;
  const [config, setConfig] = useState({
    appendPadding: 0,
    data: undefined,
    angleField: props.angleField,
    colorField: props.colorField,
    radius: 0.9,
    legend: false,
    width: 210,
    height: 210,
    label: {
      type: "inner",
      autoRotate: false,
      offset: "-35%",
      content: (content) => {
        return `${content[props.colorField]}\n${(content.percent * 100).toFixed(
          0
        )}%\n${content[props.angleField]}`;
      },
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
  });

  useEffect(() => {
    setConfig((current) => ({
      ...current,
      data: props.data,
    }));
  }, [props.data]);

  return !loading && config?.data ? (
    !props.isNoData ? (
      <Pie {...config} />
    ) : (
      <div className="center-section-empty">
        <Empty />
      </div>
    )
  ) : (
    <div className="center-loader-bar">
      <Spin size="large" />{" "}
    </div>
  );
};

PieChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default PieChart;
